export const DUPLICATE_FROM_PARAM = "from";
export const SCENARIO_STAGE_PARAM = "stage";

export enum ScenarioBuilderLabel {
    Sensitivities = "Add sensitivities",
    AddUpgrades = "Add upgrades",
    CostAssumptions = "Cost assumptions",
    SubmitScenario = "Submit scenario",
    EditScenario = "Edit scenario",
    NewScenario = "New scenario"
}

export const BULK_SCENARIO_UPLOAD_PATH = "bulk-upload";
